import { Box, Card, Chip, Grid, Stack, Typography } from '@mui/material';
import RedeemRounded from '@mui/icons-material/RedeemRounded';
import WorkspacePremiumRounded from '@mui/icons-material/WorkspacePremiumRounded';
import { money } from '@/billing/planCopy';
import { usePublicPlans } from '../api';

const STEPS = [
  'Entre na plataforma e pegue o seu link e o seu cupom em "Indique e ganhe".',
  'Envie para alunos, amigos ou outros profissionais. Os alunos que você convida para o seu espaço contam sozinhos.',
  'Quando a pessoa fizer o primeiro pagamento (o Plus ou um plano de profissional), você recebe R$ 10 por Pix, e ela ganha R$ 5 de desconto nessa fatura.',
];

/** Brand site: the referral program and the students' own plan (Plus). */
export function ReferralAndPlus() {
  const plans = usePublicPlans();
  const plus = plans.data?.find((p) => p.kind === 'personal');
  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 7 }}>
        <Card sx={{ p: { xs: 2.5, md: 3.5 }, height: '100%' }}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
              <RedeemRounded color="primary" sx={{ fontSize: 40 }} />
              <Typography variant="h5" component="h3" sx={{ fontWeight: 800 }}>
                Indique e ganhe R$ 10 por Pix
              </Typography>
            </Stack>
            <Typography color="text.secondary">
              Para cada pessoa que você trouxer e que virar pagante. Sem limite de indicações, e
              você não precisa ter plano pago para participar.
            </Typography>
            <Stack component="ol" spacing={1.25} sx={{ pl: 0, m: 0, listStyle: 'none' }}>
              {STEPS.map((step, index) => (
                <Stack
                  component="li"
                  key={step}
                  direction="row"
                  spacing={1.5}
                  sx={{ alignItems: 'flex-start' }}
                >
                  <Chip size="small" color="primary" label={index + 1} sx={{ minWidth: 28 }} />
                  <Typography variant="body2">{step}</Typography>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        <Card sx={{ p: { xs: 2.5, md: 3.5 }, height: '100%' }}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
              <WorkspacePremiumRounded color="primary" sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h5" component="h3" sx={{ fontWeight: 800 }}>
                  {plus?.name ?? 'Plus'}, para o aluno
                </Typography>
                {plus?.prices.month && (
                  <Typography color="text.secondary">
                    {money(plus.prices.month)} por mês
                    {plus.prices.year ? ` ou ${money(plus.prices.year)} por ano` : ''}
                  </Typography>
                )}
              </Box>
            </Stack>
            <Typography color="text.secondary">
              O aluno entra de graça no espaço do profissional. Se quiser mais, assina o Plus e
              ganha finanças pessoais e fotos de refeição analisadas por IA, em todos os espaços em
              que estiver.
            </Typography>
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
}
